import { Box, Typography, useMediaQuery } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Motion } from './Motion/Motion';
import StarIcon from '@mui/icons-material/Star';
import { getAppRatingInfo } from './Ratings/app_ratings';
import { Link, useLocation } from 'react-router-dom';
import { appYellow } from '../Classes/theme';


export default function Banner({ appPageData = null, shopLink = "", width = 900 }) {
    const location = useLocation();
    const xs = useMediaQuery("(max-width:475px)");
    const maxDisplay = useMediaQuery(`(max-width:${width}px)`);

    // seconds
    const timeToShow = 16;
    // bar height
    const height = xs ? 90 : 100;
    const iconSize = xs ? 50 : 70;
    const space = 16;

    const [slide, setSlide] = useState(false);
    const [show, setShow] = useState(false);

    const [enableHide, setEnableHide] = useState(false);

    const app = getAppRatingInfo(appPageData.link);

    useEffect(() => {
        if (!maxDisplay || !appPageData) return;

        setTimeout(() => {
            showBanner();
        }, timeToShow * 1000)
    }, [location]);

    useEffect(() => {
        if (!maxDisplay) return;

        if (show) {
            setTimeout(() => {
                setSlide(true);
            }, 50);
        }
    }, [show]);

    function showBanner() {
        if (!maxDisplay) return;

        disableScroll(true);
        setShow(true);

        setTimeout(() => {
            setEnableHide(true);
        }, 600);
    }

    function hideBanner() {
        if (!enableHide) return;
        disableScroll(false);
        setSlide(false);
        setTimeout(() => {
            setShow(false);
        }, 300);
    }

    function disableScroll(disable = false) {
        document.body.style.overflow = disable ? 'hidden' : '';
    }

    if (!maxDisplay) {
        return <></>;
    }

    return (
        <Box sx={{
            display: show ? 'flex' : 'none', position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', bgcolor: show ? 'rgba(0,0,0,0.5)' : 'transparent', zIndex: '999999',
            minWidth: '380px'
        }} onClick={() => {
            hideBanner(false);
        }}>
            <Box sx={{ display: 'flex', position: 'absolute', top: slide ? "0px" : `-${height}px`, ledt: 0, width: '100%', transition: "top .3s ease-in-out", height: `${height}px`, bgcolor: 'white', boxShadow: "0px 3px 5px 0px rgba(0,0,0,0.2)" }}
                onClick={(e) => {
                    e.stopPropagation();
                    //e.preventDefault();
                }}>
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', alignContent: 'center', justifyContent: 'center', pl: `${space}px`, pr: `${space + 4}px`, width: '100%' }}>
                    {/*<Motion>
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', alignContent: 'center', width: `${iconSize + 4}px`, height: `${iconSize + 4}px`, cursor: 'pointer', }} onClick={() => {
                            hideBanner();
                        }}>
                            <CloseRoundedIcon sx={{ fill: 'grey', width: `${iconSize}px`, height: `${iconSize}px` }} />

                        </Box>
                    </Motion>*/}
                    <Motion scale={1.03}>
                        <Box sx={{ width: `${iconSize}px`, height: `${iconSize}px` }}>
                            <Link style={{ width: `${iconSize}px`, height: `${iconSize}px` }} to={shopLink} target='_blank'>
                                <Box component={'img'} src={app.icon} sx={{ width: `${iconSize}px`, height: `${iconSize}px` }} />
                            </Link>
                        </Box>
                    </Motion>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', alignContent: 'flex-start', justifyContent: 'center', ml: `${space}px` }}>
                        <Typography variant='medium' sx={{
                            color: '#1A1C1E', width: '100%', textAlign: 'left', maxWidth: 'none', ...(xs ? {
                                fontSize: '18px',
                                lineHeight: "24px",
                            } : {})
                        }}>{app.name}</Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'row', }}>
                            {[...Array(5)].map((_, i) => <>
                                <StarIcon sx={{ fill: appYellow, width: xs ? '22px' : '24px', height: xs ? '22px' : '24px', }} /></>)}
                        </Box>
                    </Box>
                    <Motion>
                        <Box sx={{ ml: 'auto' }}>
                            <Link style={{ textDecoration: 'none' }} to={shopLink} target='_blank'>
                                <Box sx={{
                                    borderRadius: '24px', width: '95px', height: '40px', bgcolor: appPageData.color,
                                    ml: 'auto', display: 'flex', alignItems: 'center', alignContent: 'center', justifyContent: 'center'
                                }}>
                                    <Typography variant='button' sx={{ mt: '1px' }}>Instalovat</Typography>
                                </Box>
                            </Link>
                        </Box>
                    </Motion>

                </Box>
            </Box>
        </Box>
    )
}

